import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 512 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M225.79 283.51H110.95v34.32h72.04c-10.95 22.38-34.08 37.61-60.05 37.61-36.81 0-66.76-29.95-66.76-66.76s29.95-66.76 66.76-66.76c3.47 0 6.96.27 10.35.8l23.19 3.6-3.6-23.19c-.53-3.39-.79-6.88-.79-10.35 0-36.81 29.95-66.76 66.76-66.76s66.76 29.95 66.76 66.76h34.32c0-55.73-45.34-101.07-101.07-101.07s-98.31 42.63-100.95 96.03c-53.4 2.64-96.03 46.91-96.03 100.95s45.34 101.07 101.07 101.07c49.97 0 92.98-37.25 100.05-86.66l2.8-19.59Z",
  style: {"fill":"#fed124"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M490.13 340.2v-34.4l-29.1-4.3c-2.4-10.7-6.7-20.8-12.3-29.8l17.5-23.6-24.3-24.3-23.6 17.5c-9-5.7-19.1-9.9-29.8-12.3l-4.3-29.1h-34.4l-4.3 29.1c-10.7 2.4-20.8 6.7-29.8 12.3l-23.6-17.5-24.3 24.3 17.5 23.6c-5.7 9-9.9 19.1-12.3 29.8l-29.1 4.3v34.4l29.1 4.3c2.4 10.7 6.7 20.8 12.3 29.8l-17.5 23.6 24.3 24.3 23.6-17.5c9 5.7 19.1 9.9 29.8 12.3l4.3 29.1h34.4l4.3-29.1c10.7-2.4 20.8-6.7 29.8-12.3l23.6 17.5 24.3-24.3-17.5-23.6c5.7-9 9.9-19.1 12.3-29.8zm-123.2 53c-38.8 0-70.2-31.4-70.2-70.2s31.4-70.2 70.2-70.2 70.2 31.4 70.2 70.2-31.4 70.2-70.2 70.2",
  style: {"fill":"#004f7d"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }